import { render, staticRenderFns } from "./BcPhoneDialog.vue?vue&type=template&id=0077d0c0"
import script from "./BcPhoneDialog.vue?vue&type=script&lang=js"
export * from "./BcPhoneDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports